import {ContactFormController as controller} from './controller.js';
import templateUrl from './template.html';

export const contactFieldsComponent = {
    templateUrl: templateUrl,
    controller: controller,
    bindings: {
        // pass in the contact
        contact: '<',
        // pass in a refernce to the form form the parent for validation.
        form: '=',
    }
}


export default contactFieldsComponent;


// WEBPACK FOOTER //
// ./app/jangl/contact-fields/component.js